import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <main className="mx-auto max-w-3xl px-4 py-10 text-sm leading-relaxed text-foreground">
      <Link to="/" className="text-xs uppercase tracking-wide opacity-60 hover:opacity-100">
        ← Home
      </Link>
      <h1 className="mt-6 text-3xl font-semibold">Privacy Policy</h1>
      <p className="mt-2 text-xs opacity-60">Last updated: 5 May 2026</p>

      <section className="mt-8 space-y-3">
        <h2 className="text-lg font-semibold">1. Who we are</h2>
        <p>
          Nako Pula is operated by <strong>Nako Tech Pty Ltd</strong>, a company registered in
          Botswana ("Nako Tech", "we", "us"). For questions about this policy contact{' '}
          <a className="underline" href="mailto:privacy@nakotech.africa">
            privacy@nakotech.africa
          </a>
          .
        </p>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">2. What data we collect</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Account data: name, email, phone, business name, VAT number.</li>
          <li>Accounting data you enter: invoices, receipts, journal entries, customers, suppliers, payroll, fixed assets.</li>
          <li>Receipt images you upload (processed by Google Gemini for OCR; see §5).</li>
          <li>Telemetry: device type, browser, IP, page views — used solely to keep the service reliable.</li>
        </ul>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">3. Where your data is stored — cross-border transfer notice</h2>
        <p>
          Nako Pula stores all customer data on <strong>Supabase</strong> infrastructure in the{' '}
          <strong>European Union (Ireland, eu-west-1)</strong>. Supabase is bound by EU GDPR — a
          regime recognised as offering protections at least equivalent to Botswana's Data
          Protection Act 2018.
        </p>
        <p>
          By using Nako Pula you consent to your data being processed in the EU under GDPR
          safeguards, in line with section 48 of the Botswana Data Protection Act 2018. You can
          request a copy of our internal cross-border transfer assessment at any time.
        </p>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">4. How Nako Tech uses your data</h2>
        <p>By creating an account you agree that Nako Tech may use your data to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Run the service</strong> — power your dashboards, reports, BURS exports, reminders and OCR.</li>
          <li>
            <strong>Quality assurance</strong> — Nako Tech administrators may review your account
            (including journal entries, receipts and uploaded images) to debug issues, improve
            accuracy and train staff. Reviews are logged in our audit trail.
          </li>
          <li>
            <strong>Marketing and product improvement</strong> — Nako Tech may use anonymised
            and aggregated data, and (with this agreement) identifiable data, to publish case
            studies, generate testimonials, build benchmarks for Botswana SMEs, and improve our
            AI models. You may opt out of identifiable marketing use at any time by emailing{' '}
            <a className="underline" href="mailto:privacy@nakotech.africa">
              privacy@nakotech.africa
            </a>{' '}
            — quality assurance access continues regardless of marketing opt-out.
          </li>
        </ul>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">5. Sub-processors</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Supabase Inc.</strong> (Ireland / EU) — database, auth, storage, edge functions.</li>
          <li><strong>Google LLC — Gemini API</strong> — receipt OCR and AI-suggested journal entries. Receipt images and transaction descriptions are sent to Gemini for processing only.</li>
          <li><strong>GitHub Pages</strong> — static hosting of the web app.</li>
          <li><strong>Telegram Messenger LLP</strong> — optional reminder delivery (only if you link a Telegram chat).</li>
        </ul>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">6. Your rights under the Botswana DPA</h2>
        <p>
          You have the right to access, correct, port, or delete your data; withdraw consent for
          marketing use; and lodge a complaint with the Botswana Information &amp; Data Protection
          Commissioner. Email{' '}
          <a className="underline" href="mailto:privacy@nakotech.africa">privacy@nakotech.africa</a>{' '}
          and we will respond within 30 days.
        </p>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">7. Retention</h2>
        <p>
          Live data is kept for as long as your account is active. On account closure you can
          export your data; we then delete it within 60 days, except where Botswana tax law
          requires longer retention of accounting records (currently 5 years).
        </p>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">8. Changes</h2>
        <p>
          Material changes to this policy will be announced by email at least 14 days before they
          take effect.
        </p>
      </section>

      <p className="mt-10 text-xs opacity-60">
        See also the <Link to="/terms" className="underline">Terms of Service</Link>.
      </p>
    </main>
  );
}
